export { P as Panel, W as Widget } from './index-97ee4443.js';
import 'react';
import '@uploadcare/client-suspense';
import 'react-fast-compare';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/react-widget/dist/esm/index.js
// module id = 1515
// module chunks = 71